"use client"

import Image from "next/image"
import { Card, CardContent } from "@/components/ui/card"
import { Truck, Shield, Headphones } from "lucide-react"

const values = [
  {
    icon: Truck,
    title: "Fast Delivery",
    description: "We’re committed to quick and reliable shipping so you receive your products promptly.",
  },
  {
    icon: Shield,
    title: "Quality Guarantee",
    description: "We stand behind every item with our promise of quality and dependability.",
  },
  {
    icon: Headphones,
    title: "Customer Support",
    description: "Our friendly customer service team is here during office hours to assist you with any questions or concerns.",
  },
]

export function AboutPage() {
  return (
    <div className="w-full max-w-[1920px] mx-auto px-4 sm:px-6 lg:px-8 xl:px-12 2xl:px-16 py-16">
      {/* Hero Section */}
      <div className="text-center mb-16">
        <h1 className="text-4xl md:text-5xl font-bold mb-6">About Us</h1>
        <p className="text-xl text-muted-foreground max-w-3xl mx-auto text-pretty">
          AEPAC is a Mumbai-based e-commerce platform specializing in pre-owned commercial laptops. We provide reliable, quality-checked devices from trusted brands, ensuring cost-effective solutions for businesses and individuals. Our focus is on transparency, performance, and dependable customer support.
        </p>
      </div>

      {/* Story Section */}
      <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
        <div className="text-center md:text-left">
          <h2 className="text-3xl font-bold mb-6">Our Story</h2>
          <div className="space-y-4 text-muted-foreground text-center md:text-left text-pretty">
            <p>
              AEPAC was established with the mission to transform how people shop online by prioritizing customer satisfaction and quality assurance. Over the years, we have curated a diverse selection of premium products, meeting the needs of customers who demand reliability and transparency. From the start, our core focus has been to offer only those products that we’d use ourselves.
            </p>
          </div>
        </div>
        <div className="relative h-96 rounded-lg overflow-hidden">
          <Image src="/aepac-logo-black-text.png" alt="AEPAC Logo" fill className="object-contain bg-white" />
        </div>
      </div>

      {/* Values Section */}
      <div className="mb-16 text-center">
        <h2 className="text-3xl font-bold mb-6">What We Stand For</h2>
        <p className="text-lg text-muted-foreground mb-8">
          We are guided by the values that shape every aspect of our business:
        </p>
        <div className="flex flex-col md:flex-row justify-center items-center gap-8">
          {values.map((value, idx) => {
            const Icon = value.icon
            return (
              <Card key={idx} className="flex flex-col items-center p-8 w-full md:w-80 min-h-72">
                <div className="mb-4">
                  <Icon className="h-10 w-10 text-primary mb-2" />
                </div>
                <h3 className="text-xl font-semibold mb-2">{value.title}</h3>
                <p className="text-muted-foreground text-center text-pretty">{value.description}</p>
              </Card>
            )
          })}
        </div>
      </div>

      <div className="text-center mt-12">
        <p className="text-lg text-primary font-semibold">
          At AEPAC, our customers are at the heart of everything we do. Shop with us and discover the difference!
        </p>
      </div>
    </div>
  )
}
